import { Announcement } from "@mui/icons-material";
import Banner from "../Banner";
import AnnouncementPanel from "../AnnouncementPanel";

export const Home = () => {
    return (
        <div>
             <Banner />
             <AnnouncementPanel />
        </div>
    );
};